// @flow

import React, { type Node } from 'react';

import appPage from 'web-ssr/browser/pages/appPage';

import CheckPendingPolicies from 'web-ssr/app/common/components/CheckPendingPolicies';
import ErrorPage from 'web-ssr/pages/_error';
import Survey from 'web-ssr/app/common/components/Survey';
import frontendAppConfig from 'web-ssr/frontend-app.config';
import { GoogleTagManager } from 'web-ssr/app/common/tracking/GoogleTagManager';
import { CurrentAccountIdProvider } from '@zapier/common-hooks';

import type { RouterProps } from 'web-ssr/app/common/next/types';

type Props = {
  Component: () => Node,
  err?: Error,
  pageProps: {
    forceRecordSession?: boolean,
  },

  router: RouterProps,
  statusCode: number,
};

class ZapierApp extends React.Component<Props> {
  render() {
    const { Component, pageProps, router, statusCode }: Props = this.props;
    const currentAccountId = router.query.context
      ? Number(router.query.context)
      : undefined;
    return (
      <CurrentAccountIdProvider currentAccountId={currentAccountId}>
        {statusCode && statusCode > 399 ? (
          <ErrorPage statusCode={statusCode} />
        ) : (
          <React.Fragment>
            <Component {...pageProps} />
            <Survey />
            <GoogleTagManager />
            <CheckPendingPolicies />
          </React.Fragment>
        )}
      </CurrentAccountIdProvider>
    );
  }
}

export default appPage(ZapierApp, frontendAppConfig);
